import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { ProductVariation } from 'models/productsReferential';
import type { Collection } from 'state/utils/types';

export type StaticWorkspaceState = {
  quoteId?: string;
  aiGeneratedFields?: string[];
  productVariation: Partial<ProductVariation>;
  client: Nullable<ISalesCounterpart>;
  isFetchingTabContent: boolean;
  isProductValidated: boolean;
};

export type StaticWorkspaceStateMap = Collection<StaticWorkspaceState>;

export const initialStaticWorkSpaceState: StaticWorkspaceStateMap = {};
